var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("div", { staticStyle: { position: "relative" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query"
            }
          ],
          ref: "search",
          staticClass: "px-5 pl-10 py-2",
          staticStyle: { width: "100%" },
          attrs: {
            type: "text",
            placeholder: _vm.placeHolder,
            disabled: _vm.disabled
          },
          domProps: { value: _vm.query },
          on: {
            blur: function($event) {
              _vm.resultatsDeRechercheVisible = false
            },
            click: function($event) {
              _vm.resultatsDeRechercheVisible = true
            },
            focus: function($event) {
              _vm.resultatsDeRechercheVisible = true
            },
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              },
              _vm.softReset
            ],
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.highlightPrevious.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.highlightNext.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.pressEnter()
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                _vm.resultatsDeRechercheVisible = false
              }
            ],
            keyup: _vm.startTimeout
          }
        }),
        _c(
          "div",
          {
            staticStyle: { position: "absolute", left: "5px" },
            style: _vm.small ? "top:1px" : "top:5px"
          },
          [
            _c(
              "svg",
              {
                staticClass: "h-5 w-5",
                staticStyle: { color: "grey" },
                attrs: {
                  fill: "currentColor",
                  viewBox: "0 0 24 24",
                  width: _vm.small ? 16 : 24,
                  height: _vm.small ? 16 : 24
                }
              },
              [
                _c("path", {
                  staticClass: "heroicon-ui",
                  attrs: {
                    d:
                      "M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
                  }
                })
              ]
            )
          ]
        ),
        !_vm.disabled && _vm.query.length > 0
          ? _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  right: "0px",
                  color: "grey"
                },
                style: _vm.small ? "top:2px" : "top:3px",
                on: { click: _vm.reset }
              },
              [
                _c("i", {
                  staticClass: "fa fa-window-close",
                  style: _vm.small ? "font-size:1.2rem" : "",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.query.length >= 3 && _vm.resultatsDeRechercheVisible
          ? _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  "z-index": "1000",
                  "border-radius": "4px",
                  border: "1px solid #dfdfdf",
                  "box-shadow":
                    "rgba(0, 0, 0, 0.5) 0px 1px 6px, rgba(0, 0, 0, 0.5) 0px 1px 4px !important",
                  background: "white",
                  color: "black"
                },
                style: _vm.chercherProduits
                  ? _vm.afficherPrix
                    ? "width:1160px"
                    : "width:860px"
                  : "width:440px"
              },
              [
                !_vm.recherchePrete
                  ? _c("div", { staticClass: "card m-0 border-0" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("i", [_vm._v("Recherche en cours...")])
                      ])
                    ])
                  : _vm.resultatRecherche.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "card table-scroll m-0",
                        class: _vm.small
                          ? "max-height-responsive-35"
                          : "max-height-responsive-65"
                      },
                      [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-bordered table-sm text-center table-header"
                          },
                          [
                            _c("colgroup", [
                              _vm.chercherProduits ||
                              (_vm.chercherIngredients && _vm.chercherRecettes)
                                ? _c("col", { attrs: { width: "160" } })
                                : _vm._e(),
                              _c("col", { attrs: { width: "280" } }),
                              _vm.chercherProduits
                                ? _c("col", { attrs: { width: "420" } })
                                : _vm._e(),
                              _vm.chercherProduits && _vm.afficherPrix
                                ? _c("col", { attrs: { width: "150" } })
                                : _vm._e(),
                              _vm.chercherProduits && _vm.afficherPrix
                                ? _c("col", { attrs: { width: "150" } })
                                : _vm._e()
                            ]),
                            _c("thead", [
                              _vm.chercherProduits ||
                              (_vm.chercherIngredients && _vm.chercherRecettes)
                                ? _c("th", [_vm._v("Famille")])
                                : _vm._e(),
                              _c("th", [_vm._v("Ingrédient")]),
                              _vm.chercherProduits
                                ? _c("th", [_vm._v("Produit")])
                                : _vm._e(),
                              _vm.chercherProduits && _vm.afficherPrix
                                ? _c("th", [_vm._v("Prix 1")])
                                : _vm._e(),
                              _vm.chercherProduits && _vm.afficherPrix
                                ? _c("th", [_vm._v("Prix 2")])
                                : _vm._e()
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "table-body" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-bordered table-sm text-center"
                            },
                            [
                              _c("colgroup", [
                                _vm.chercherProduits ||
                                (_vm.chercherIngredients &&
                                  _vm.chercherRecettes)
                                  ? _c("col", { attrs: { width: "160" } })
                                  : _vm._e(),
                                _c("col", { attrs: { width: "280" } }),
                                _vm.chercherProduits
                                  ? _c("col", {
                                      attrs: {
                                        width: _vm.afficherPrix ? "420" : "415"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.chercherProduits && _vm.afficherPrix
                                  ? _c("col", { attrs: { width: "150" } })
                                  : _vm._e(),
                                _vm.chercherProduits && _vm.afficherPrix
                                  ? _c("col", { attrs: { width: "145" } })
                                  : _vm._e()
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.resultatRecherche, function(
                                  resultat,
                                  index
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key: index,
                                      on: {
                                        click: function($event) {
                                          return _vm.selectionner(resultat)
                                        },
                                        mousedown: function($event) {
                                          $event.preventDefault()
                                          _vm.resultatsDeRechercheVisible = true
                                        },
                                        mouseover: function($event) {
                                          return _vm.focusOn(index)
                                        }
                                      }
                                    },
                                    [
                                      _vm.chercherProduits ||
                                      (_vm.chercherIngredients &&
                                        _vm.chercherRecettes)
                                        ? _c(
                                            "td",
                                            {
                                              class: [
                                                {
                                                  "text-italic":
                                                    _vm.pourChoixIngredient
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(resultat.nomFamille)
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "td",
                                        {
                                          class: [
                                            { bold600: _vm.pourChoixIngredient }
                                          ]
                                        },
                                        [
                                          !resultat.nomIngredient
                                            ? _c(
                                                "span",
                                                { staticClass: "text-error" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-exclamation-triangle"
                                                  }),
                                                  _vm._v(
                                                    " Ingrédient à configurer"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(_vm._s(resultat.nomIngredient))
                                        ]
                                      ),
                                      _vm.chercherProduits
                                        ? _c(
                                            "td",
                                            {
                                              class: [
                                                {
                                                  "text-italic":
                                                    _vm.pourChoixIngredient
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(resultat.designation) +
                                                  " "
                                              ),
                                              _vm.favoris.includes(resultat.id)
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-star text-warning"
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.chercherProduits && _vm.afficherPrix
                                        ? _c(
                                            "td",
                                            {
                                              class: [
                                                {
                                                  "text-italic":
                                                    _vm.pourChoixIngredient
                                                }
                                              ]
                                            },
                                            [
                                              resultat.prix1
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("afficherPrix")(
                                                          resultat.prix1
                                                        )
                                                      ) +
                                                        " x " +
                                                        _vm._s(resultat.pcb1) +
                                                        " " +
                                                        _vm._s(resultat.uc)
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.chercherProduits && _vm.afficherPrix
                                        ? _c(
                                            "td",
                                            {
                                              class: [
                                                {
                                                  "text-italic":
                                                    _vm.pourChoixIngredient
                                                }
                                              ]
                                            },
                                            [
                                              resultat.prix2
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("afficherPrix")(
                                                          resultat.prix2
                                                        )
                                                      ) +
                                                        " x " +
                                                        _vm._s(resultat.pcb2) +
                                                        " " +
                                                        _vm._s(resultat.uc)
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  : _c("div", { staticClass: "card m-0 border-0" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _vm._v(" Aucun résultat pour '"),
                        _c("strong", [_vm._v(_vm._s(_vm.query))]),
                        _vm._v("' ")
                      ]),
                      _vm.ajoutActif
                        ? _c("div", { staticClass: "card-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.declencherAjout()
                                  },
                                  mousedown: function($event) {
                                    $event.preventDefault()
                                    _vm.resultatsDeRechercheVisible = true
                                  }
                                }
                              },
                              [_vm._v(" Ajouter un produit ")]
                            )
                          ])
                        : _vm._e()
                    ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }